// #HR_WAGE_SPLIT_V1 (2026-10-20) — Bill: "Wages are all in now and we need not have anyone going into this."
// Pay lives in its own record, app_storage 'hr-wages' = { <hrid>: { originWage, raises, … } }, which the database lets only
// Owners, HR (Kris — reviews wages and sets up increases) and Payroll (Trista) read or write. 'hr-employees' carries everything
// else (names, roles, driver file, training…) for the screens that need it, with no pay in it.
// App.js sg/ss do the join: reading 'hr-employees' merges hr-wages back in when this person is allowed to see it; saving
// 'hr-employees' splits pay out into hr-wages first. If the pay can't be saved there, the record is saved whole so nothing is lost.
export const HR_WAGES_KEY = 'hr-wages';
export const PAY_FIELDS = ['originWage', 'raises', 'lastRaise', 'healthCost', 'dentalCost', 'visionCost', 'lifeCost',
  'cdlLoanTotal', 'cdlLoanWeekly', 'cdlLoanStart', 'cdlLoanMature', 'cellAllow', 'cellAllowWk'];

export const splitPay = (emps) => {
  const stripped = []; const pay = {};
  (emps || []).forEach(e => {
    if (!e || typeof e !== 'object' || !e.hrid) { stripped.push(e); return; }
    const s = { ...e }; const p = {}; let any = false;
    PAY_FIELDS.forEach(f => { if (f in s) { p[f] = s[f]; any = true; delete s[f]; } });
    if (any) pay[e.hrid] = p;
    stripped.push(s);
  });
  return { stripped, pay };
};
export const mergePay = (emps, wages) => (emps || []).map(e => (e && e.hrid && wages && wages[e.hrid]) ? { ...e, ...wages[e.hrid] } : e);
